import React from "react";

interface IProps {
  theme: "light" | "dark";
  isSelected: boolean;
  onClick: () => void;
  onOver: () => void;
  onOut: () => void;
}

export const ReviewStars = ({
  theme,
  isSelected,
  onClick,
  onOver,
  onOut,
}: IProps) => {
  return (
    <svg
      role="img"
      aria-label="review star"
      width="40"
      height="41"
      viewBox="0 0 40 41"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="ai-review-start"
      onClick={onClick}
      onMouseOver={onOver}
      onMouseOut={onOut}
    >
      <path
        data-testid="star-path"
        d="M17.8542 1.89144L12.972 12.2339L2.04863 13.8978C0.089755 14.1946 -0.69529 16.7177 0.725268 18.1629L8.62806 26.2087L6.7589 37.5745C6.42245 39.629 8.49348 41.1678 10.2281 40.207L20 34.8405L29.7719 40.207C31.5065 41.16 33.5775 39.629 33.2411 37.5745L31.3719 26.2087L39.2747 18.1629C40.6953 16.7177 39.9102 14.1946 37.9514 13.8978L27.028 12.2339L22.1458 1.89144C21.271 0.0479213 18.7365 0.0244867 17.8542 1.89144Z"
        fill={
          isSelected ? "#F4DA23" : theme === "light" ? "#D9D9D9" : "#3D444D"
        }
      />
    </svg>
  );
};
